import { render, staticRenderFns } from "./UiSidebar.vue?vue&type=template&id=24544c23&scoped=true&"
import script from "./UiSidebar.vue?vue&type=script&lang=ts&"
export * from "./UiSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./UiSidebar.vue?vue&type=style&index=0&id=24544c23&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24544c23",
  null
  
)

export default component.exports